// Packages
import React, { Component } from "react";
import { Link } from "react-router-dom";

// Views
import SchoolAdminDashboard from "../schoolAdminPortal/schoolAdminDashboard";

//Styles
import "../schoolAdminPortal/schoolAdmin.css";

// Material Ui
import MaterialTable from "material-table";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";

// Services
import userService from "../../services/user.service";

const data = [
  {
    id: "100",
    schoolName: "Ross Taylor",
    totalStorage: "athelete@example.com",
    remaining: "Striker",
    remainingper: "+44-8927471190",
    lastModifed: "Group 1",
    status: "2020",
  },
  {
    id: "100",
    schoolName: "Ross Taylor",
    totalStorage: "athelete@example.com",
    remaining: "Striker",
    remainingper: "+44-8927471190",
    lastModifed: "Group 6",
    status: "2021",
  },
  {
    id: "100",
    schoolName: "Ross Taylor",
    totalStorage: "athelete@example.com",
    remaining: "Striker",
    remainingper: "+44-8927471190",
    lastModifed: "Group 4",
    status: "2021",
  },
  {
    id: "100",
    schoolName: "Ross Taylor",
    totalStorage: "athelete@example.com",
    remaining: "Striker",
    remainingper: "+44-8927471190",
    lastModifed: "Group 1",
    status: "2020",
  },
  {
    id: "100",
    schoolName: "Ross Taylor",
    totalStorage: "athelete@example.com",
    remaining: "Striker",
    remainingper: "+44-8927471190",
    lastModifed: "Group 2",
    status: "2021",
  },
];

const columns = [
  {
    title: "id",
    field: "id",
    hidden: true,
  },
  {
    title: "ATHLETE NAME",
    field: "schoolName",
    render: (row) => (
      <Link to={`/schooladmincoachdetails/${row.id}`}>
        <div className="link-blue" key={row.id}>
          {row.schoolName}
        </div>
      </Link>
    ),
  },
  {
    title: "EMAIL",
    field: "totalStorage",
  },
  {
    title: "POSITION PLAYED",
    field: "remaining",
  },
  {
    title: "PHONE NO.",
    field: "remainingper",
  },
  {
    title: "GROUP",
    field: "lastModifed",
  },
  {
    title: "GRAD YEAR",
    field: "status",
  },
  {
    render: () => (
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
      >
        <MoreVertIcon />
      </IconButton>
    ),
  },
];

class Storage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allSchoolList: [],
    };
  }
  componentDidMount() {
    this.getSchoolData();
  }

  getSchoolData() {
    userService
      .getAllSchool()
      .then((response) => {
        console.log(response);
        var allSchoolList = response.data.data.schools;
        console.log(allSchoolList);
        this.setState({ allSchoolList });
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }
  render() {
    return (
      <div className="content">
        <div className="content-layout p-0">
          <SchoolAdminDashboard />
          <div className="container">
            <div className="row">
              <div className="col-6 col-sm-6 col-md-6 col-lg-6 top-strip pt-28">
                <h4 className="fs-24 black bold ml-14">ATHLETES</h4>
              </div>
              <div className="col-6 col-sm-6 col-md-6 col-lg-6 top-strip pt-28">
                <div className="row">
                  <div className="col-6 col-sm-6 col-md-6 col-lg-6 text-right"></div>
                  <div className="col-6 col-sm-6 col-md-6 col-lg-6 text-right">
                    <Link className="" to="/saddschoolathlete">
                      <Button className="addBtn" startIcon={<AddIcon />}>
                        Add New Athlete
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="clear20"></div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
            <MaterialTable
              title=""
              data={data}
              columns={columns}
              options={{
                filtering: true,
                selection: true,
                headerStyle: { fontFamily: "Rajdhani-Bold", fontSize: 14 },
                rowStyle: (rowData) => ({
                  backgroundColor: rowData.tableData.checked ? "#37b15933" : "",
                  fontSize: 17,
                  fontFamily: "Rajdhani-SemiBold",
                }),
                paging: true,
                pageSize: 5,
                emptyRowsWhenPaging: true,
                pageSizeOptions: [5, 20, 40, 60, 80, 100],
              }}
            ></MaterialTable>
          </div>
        </div>
      </div>
    );
  }
}
export default Storage;
